module.exports = __webpack_public_path__ + "static/media/Group_By.999e5a98.svg";